import { render } from "./App.vue?vue&type=template&id=618b2f20"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=618b2f20&lang=css"

import exportComponent from "E:\\软件项目\\深圳官网\\official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__